import { Flex } from '@radix-ui/themes'
import { WalletAppList } from 'features/wallets/components/wallet-app-list'
import { DataTestIDs } from 'shared/constants'
import { useConnectWalletApp } from '../../hooks/use-connect-wallet-app'
import { isConnectWalletOpenVar } from '../../store/dialogs'

/** The wallet apps a signed-in user can connect; the dialog closes once one is connected. */
export const WalletAppConnectors: React.FC = () => {
  const { connectApp, isConnecting } = useConnectWalletApp()

  return (
    <Flex
      direction='column'
      justify='center'
      align='stretch'
      width='100%'
      gap='4'
    >
      <WalletAppList
        isBusy={isConnecting}
        buttonTestId={DataTestIDs.buttonConnectWalletApp}
        onPick={async provider => {
          if (await connectApp(provider)) isConnectWalletOpenVar(false)
        }}
      />
    </Flex>
  )
}
